/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Selection_Options_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Selection options" |
*
* @param {Paste_Attributes_Selection_Options_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_selection_options_aria_label = /** @type {((inputs?: Paste_Attributes_Selection_Options_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Selection_Options_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options de selection")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auswahlmöglichkeiten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni di selezione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Варианты выбора")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones de selección")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択オプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयन विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções de seleção")
	return /** @type {LocalizedString} */ ("Selection options")
});